import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import generateAchDetailsPdf from '../../../helpers/generateAchDetailsPdf';

function ACHDetailsDownloadDocument(props) {
  const [beneficiaryName, setBeneficiaryName] = useState(props.beneficiaryName || "");
  const [beneficiaryAddress, setBeneficiaryAddress] = useState(props.beneficiaryAddress || "");
  const [accountNumber, setAccountNumber] = useState(props.accountNumber || "");
  const [routingNumber, setRoutingNumber] = useState(props.routingNumber || "");
  const [accountType, setAccountType] = useState(props.accountType || "");
  const [bankName, setBankName] = useState(props.bankName || "");
  const [bankAddress, setBankAddress] = useState(props.bankAddress || "");

  useEffect(() => {
    setBeneficiaryName(props.beneficiaryName || "");
    setBeneficiaryAddress(props.beneficiaryAddress || "");
    setAccountNumber(props.accountNumber || "");
    setRoutingNumber(props.routingNumber || "");
    setAccountType(props.accountType || "");
    setBankName(props.bankName || "");
    setBankAddress(props.bankAddress || "");
  }, [props]);

  const onClick = async () => {
    await generateAchDetailsPdf({
      beneficiaryName,
      beneficiaryAddress,
      accountNumber,
      routingNumber,
      accountType,
      bankName,
      bankAddress,
      bankAccountId: props.bankAccountId
    });
  };

  return (
    <>
      {props.buttonView ? (
        <Button
          onClick={onClick}
          disableElevation fullWidth size="large" type="submit" variant="contained" color="primary"
          sx={{ fontSize: 12, width: '100%', textTransform: 'none' }}>
          {props.displayMessage || "Download PDF"}
        </Button>
      ) : (
        <span onClick={onClick} style={{
          cursor: "pointer",
          color: "#1890ff",
        }}>
          {props.displayMessage || "Download PDF"}
        </span>
      )}
    </>
  );
}

export default ACHDetailsDownloadDocument;